import { Navigate } from "react-router";
import { UpdatePasswordForm } from "@/components/update-password-form";
import { passwordResetGate } from "@/lib/auth/redirect";
import { useAuth } from "@/src/auth/auth-provider";
import { usePageMeta } from "../use-page-meta";

/**
 * 재설정 메일 링크(/auth/confirm)를 거쳐 온 경우에만 연다. 그 링크가 브라우저에 남기는 표시로
 * 판단하고(lib/auth/redirect.ts passwordResetGate), 링크 검증으로 만들어진 세션도 확인한다.
 */
export default function UpdatePasswordPage() {
  const { user, loading } = useAuth();
  usePageMeta("/auth/update-password", "새 비밀번호 설정");

  if (loading) return null;
  if (!passwordResetGate.isOpen()) return <Navigate to="/auth/forgot-password" replace />;
  if (!user) return <Navigate to="/auth/login?error=confirm" replace />;

  return (
    <div className="flex flex-1 items-center justify-center p-6">
      <UpdatePasswordForm />
    </div>
  );
}
